document.addEventListener('DOMContentLoaded', function() {
  document.querySelectorAll('input[type="date"][data-disable-bounds="true"]').forEach(function(el) {
    el.removeAttribute('min');
    el.removeAttribute('max');
  });
});


// Measura Changes

(function () {
  const SOURCE_WRAP_SELECTOR = 'div.measura-text.measura-total-price';
  const DEST_WRAP_SELECTOR   = 'span.price-item--regular.measura-total-price';
  const MONEY_SELECTOR       = 'span.money';

  let sourceObserver = null;
  let destObserver = null;
  let rebindTimer = null;

  function syncMeasuraTotalPrice() {
    const sourceWrap = document.querySelector(SOURCE_WRAP_SELECTOR);
    const destWrap   = document.querySelector(DEST_WRAP_SELECTOR);
    if (!sourceWrap || !destWrap) return;

    const sourceMoney = sourceWrap.querySelector(MONEY_SELECTOR) || sourceWrap;
    const destMoney   = destWrap.querySelector(MONEY_SELECTOR) || destWrap;

    const sourceValue =
      sourceMoney.getAttribute('bucks-current') ||
      (sourceMoney.textContent || '').trim();

    if (!sourceValue) return;

    destMoney.textContent = sourceValue;

    if (destMoney.hasAttribute('bucks-current')) {
      destMoney.setAttribute('bucks-current', sourceValue);
    }
  }

  function setupObservers() {
    // Disconnect old observers (important when nodes were replaced)
    if (sourceObserver) sourceObserver.disconnect();
    if (destObserver) destObserver.disconnect();

    const sourceNode = document.querySelector(SOURCE_WRAP_SELECTOR);
    const destNode = document.querySelector(DEST_WRAP_SELECTOR);

    // If nodes not present yet, try again soon
    if (!sourceNode || !destNode) return;

    sourceObserver = new MutationObserver(() => {
      clearTimeout(sourceObserver._t);
      sourceObserver._t = setTimeout(syncMeasuraTotalPrice, 30);
    });

    sourceObserver.observe(sourceNode, {
      subtree: true,
      childList: true,
      characterData: true,
      attributes: true
    });

    destObserver = new MutationObserver(() => {
      clearTimeout(destObserver._t);
      destObserver._t = setTimeout(syncMeasuraTotalPrice, 30);
    });

    destObserver.observe(destNode, {
      subtree: true,
      childList: true,
      characterData: true,
      attributes: true
    });

    // Run once after (re)binding
    syncMeasuraTotalPrice();
  }

  function onReady(fn) {
    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', fn);
    } else {
      fn();
    }
  }

  onReady(() => {
    // Initial bind + run
    setupObservers();

    // Currency dropdown change
    document.addEventListener('change', (e) => {
      const el = e.target;
      if (!el) return;

      const looksLikeCurrency =
        el.matches('[name*="currency" i], [id*="currency" i], [class*="currency" i], select');

      if (looksLikeCurrency) {
        setTimeout(syncMeasuraTotalPrice, 50);
        setTimeout(syncMeasuraTotalPrice, 250);
        setTimeout(syncMeasuraTotalPrice, 800);
      }
    });

    // ✅ Key fix: Shopify variant change replaces HTML.
    // Watch the page and rebind observers when our price nodes are replaced.
    const pageObserver = new MutationObserver(() => {
      clearTimeout(rebindTimer);
      rebindTimer = setTimeout(() => {
        // if either node changed/missing, rebind observers
        setupObservers();
      }, 80);
    });

    pageObserver.observe(document.body, { childList: true, subtree: true });
  });
})();
document.addEventListener("DOMContentLoaded", function () {

function formatSize(text) {
  if (!text) return "";

  const lowerText = text.toLowerCase();
  const isArabic = document.documentElement.lang?.startsWith("ar");

  if (lowerText.includes("meter") || text.includes("متر")) {
    return isArabic ? "متر" : "Meter";
  }

  return text.trim();
}
  function updateAllSizeLabels() {
    const sizeRadios = document.querySelectorAll(
      'input[type="radio"][data-option-position="2"]'
    );

    sizeRadios.forEach(radio => {
      const labelSpan = document.querySelector(`label[for="${radio.id}"] span`);
      if (!labelSpan) return;

      const txt = labelSpan.textContent.trim();
      labelSpan.textContent = formatSize(txt);
    });
  }

  function updateSelectedSizeText() {
    const selectedSizeEl = document.querySelector(".selected-size-custom");
    if (!selectedSizeEl) return;

    const checkedSizeRadio = document.querySelector(
      'input[type="radio"][data-option-position="2"]:checked'
    );
    if (!checkedSizeRadio) return;

    const labelSpan = document.querySelector(`label[for="${checkedSizeRadio.id}"] span`);
    if (!labelSpan) return;

    selectedSizeEl.textContent = formatSize(labelSpan.textContent.trim());
  }

  function runAll() {
    updateAllSizeLabels();
    updateSelectedSizeText();
  }

  // Initial
  setTimeout(runAll, 120);

  // ✅ Run when ANY variant option changes (Color or Size)
  document.addEventListener("change", function (e) {
    if (e.target.matches('input[type="radio"][data-option-position="1"], input[type="radio"][data-option-position="2"]')) {
      setTimeout(runAll, 120);
      setTimeout(runAll, 350);
    }
  });

});

document.addEventListener("DOMContentLoaded", function () {

 function updateMeasurementLabel() {
  const label = document.querySelector('label[for="measurement_field"]');
  if (!label) return;

  const isArabic = document.documentElement.lang?.startsWith("ar");

  label.textContent = isArabic ? "متر:" : "Meter:";
}

  // Initial run
  setTimeout(updateMeasurementLabel, 100);

  // Re-run when variant changes (Shopify may re-render)
  document.addEventListener("change", function (e) {
    if (e.target.matches('input[type="radio"][data-option-position]')) {
      setTimeout(updateMeasurementLabel, 150);
    }
  });

});

document.addEventListener("DOMContentLoaded", function () {

  function getSelectedSizeText() {
    const checkedSizeRadio = document.querySelector(
      'input[type="radio"][data-option-position="2"]:checked'
    );
    if (!checkedSizeRadio) return "";

    const labelSpan = document.querySelector(`label[for="${checkedSizeRadio.id}"] span`);
    if (!labelSpan) return "";
    return labelSpan.textContent.trim().toLowerCase();
  }

  function setMeasurementLabel() {
   const label = document.querySelector('label[for="measurement_field"]');
  if (!label) return;

  const isArabic = document.documentElement.lang?.startsWith("ar");
  label.textContent = isArabic ? "متر:" : "Meter:";
  }

  // --- Track whether the shopper chose a meter value themselves ------------
  // suppressChoiceWatch shields our own programmatic .click() calls;
  // e.isTrusted shields programmatic selections made by the Measura app itself.
  let userPickedChoice = false;
  let suppressChoiceWatch = false;

  function clickWithoutMarkingUser(el) {
    suppressChoiceWatch = true;
    try {
      el.click();
    } finally {
      suppressChoiceWatch = false;
    }
  }

  function markUserPicked(e) {
    if (suppressChoiceWatch || !e.isTrusted) return;
    userPickedChoice = true;
  }

  document.addEventListener("click", function (e) {
    if (e.target.closest && e.target.closest("label.measura-pill")) markUserPicked(e);
  }, true);

  document.addEventListener("change", function (e) {
    if (e.target.matches &&
        e.target.matches('measura-pills-input input[type="radio"][name="choice"]')) {
      markUserPicked(e);
    }
  }, true);

  function selectMeasuraValue(targetValue) {
    const byValue = document.querySelector(
      `measura-pills-input input[type="radio"][name="choice"][value="${targetValue}"]`
    );
    if (byValue && !byValue.disabled) {
      clickWithoutMarkingUser(byValue);
      return true;
    }

    const txt = `${targetValue} m`.toLowerCase();
    const textEl = Array.from(document.querySelectorAll(".measura-pill-text"))
      .find(el => el.textContent.trim().toLowerCase() === txt);
    const label = textEl?.closest("label.measura-pill");
    const input = label?.querySelector('input[type="radio"][name="choice"]');
    console.log(label);
    if (input && !input.disabled) {
      clickWithoutMarkingUser(input);
      return true;
    }

    return false;
  }

  function handleMeasurementUI() {
    // ✅ Keep label updated (Measura re-renders it)
    setMeasurementLabel();

    const sizeText = getSelectedSizeText();
function normalizeText(text) {
  return text
    .toLowerCase()
    .trim()
    .replace(/\s+/g, " ")
    .replace(/[\u064B-\u065F]/g, ""); // remove Arabic diacritics
}

const fullRollTextEl = Array.from(document.querySelectorAll(".measura-pill-text"))
  .find(el => {
    const text = normalizeText(el.textContent);
    return (
      text === "roll" ||
      text === "طاقة"    
    );
  });
    //const fullRollTextEl = Array.from(document.querySelectorAll(".measura-pill-text"))
    //  .find(el => el.textContent.trim().toLowerCase() === "roll");
    // The Roll pill is OPTIONAL — Meter-only products have no Roll pill at all.
    // Treat it as simply absent instead of bailing out, so the Meter branch below
    // (show blocks + default 3.5m) still runs on those products.
    const fullRollLabel = fullRollTextEl ? fullRollTextEl.closest("label.measura-pill") : null;
    const fullRollInput = fullRollLabel ? fullRollLabel.querySelector('input[type="radio"]') : null;
    const hasRollPill = !!(fullRollLabel && fullRollInput);

    const measuraBlocks = document.querySelectorAll(".measura-block-entry");

    if (sizeText.includes("meter") || sizeText.includes("متر")) {
       console.log('metere');
      // ✅ Meter: hide + disable Full Roll (only if this product has one)
      if (hasRollPill) {
        fullRollLabel.style.setProperty("display", "none", "important");
        fullRollInput.disabled = true;
      }

      // ✅ Meter: show measura-block-entry (if present)
      measuraBlocks.forEach(block => {
        block.style.setProperty("display", "block", "important");
      });

      // ✅ Meter: default select 3.5m — only until the shopper picks their own value
      const checkedChoice = document.querySelector(
        'measura-pills-input input[type="radio"][name="choice"]:checked'
      );
      const is35Selected = checkedChoice && checkedChoice.value === "3.5";
      if (!is35Selected && !userPickedChoice) {
        selectMeasuraValue("3.5");
      }

    } else if (sizeText.includes("roll") || sizeText.includes("طاقة")) {
      console.log('roll');
      // ✅ Roll: show + enable Full Roll (only if this product has one)
      if (hasRollPill) {
        fullRollInput.disabled = false;

        // ✅ Roll: auto-select Full Roll
        if (!fullRollInput.checked) clickWithoutMarkingUser(fullRollInput);
      }

      // ✅ Roll: hide measura-block-entry (if present)
      measuraBlocks.forEach(block => {
        block.style.setProperty("display", "none", "important");
      });
    }
  }

  function runWithRetries() {
    // New render cycle (page load / variant change) → the 3.5 default may apply again
    userPickedChoice = false;
    setTimeout(handleMeasurementUI, 150);
    setTimeout(handleMeasurementUI, 350);
    setTimeout(handleMeasurementUI, 700);
  }

  // Initial
  runWithRetries();

  // Re-run on Color or Size change
  document.addEventListener("change", function (e) {
    if (e.target.matches(
      'input[type="radio"][data-option-position="1"], input[type="radio"][data-option-position="2"]'
    )) {
      runWithRetries();
    }
  });

});

document.addEventListener("DOMContentLoaded", function () {

  function getSelectedMeasuraValue() {
    const selected = document.querySelector('.measura-pills input[name="choice"]:checked');
    if (!selected) return 0;
    return parseFloat(selected.value) || 0;
  }

  function getQuantity() {
    const qtyInput = document.querySelector('input[name="quantity"]');
    if (!qtyInput) return 1;
    return parseInt(qtyInput.value) || 1;
  }

 function updateTotalLength() {

  const measuraValue = getSelectedMeasuraValue();
  const quantity = getQuantity();

  const total = measuraValue * quantity;

  setTimeout(() => {
    const totalInput = document.querySelector(
      'input[name="properties[Total Length]"]'
    );

    if (!totalInput) return;

    totalInput.value = total > 0 ? total + " Meter" : "";

    // Trigger change event (VERY IMPORTANT)
    totalInput.dispatchEvent(new Event('change', { bubbles: true }));

  }, 200);
}

  /* -------------------------
     Event Listeners
  --------------------------*/

  // Measura change
  document.addEventListener("change", function (e) {
    if (e.target.matches('.measura-pills input[name="choice"]')) {
      updateTotalLength();
    }
  });

  // Quantity change
  document.addEventListener("input", function (e) {
    if (e.target.matches('input[name="quantity"]')) {
      updateTotalLength();
    }
  });

  // Variant change (Shopify options)
  document.addEventListener("change", function (e) {
    if (e.target.matches('[data-option-position]')) {
      setTimeout(updateTotalLength, 300);
    }
  });
  document.addEventListener("input", function (e) {
  if (e.target.matches('input[name="quantity"]')) {
    updateTotalLength();
  }
});

/* When user clicks + / - buttons */
document.addEventListener("click", function (e) {
  if (e.target.closest(".quantity-selector__button")) {
    setTimeout(updateTotalLength, 150);
  }
});

  // Initial run
  setTimeout(updateTotalLength, 500);

});


// Bucks 3 Digits